import React from 'react'
import { intl } from 'lang/intl'

import {
  IconComponent,
  TooltipComponent,
  // @ts-expect-error — importing JS
} from '../../../sharedLegacy/components'

import {
  type Participant,
  type QualityStats,
  useParticipantQualityStats,
} from '../../../webrtc/webRTCRoom'

import './QualityIndicatorComponent.scss'

const getIcon = (quality: QualityStats | null, enableGlow: boolean) => {
  const size = [13, 13]

  if (enableGlow) {
    if (quality === 'excellent') {
      return (
        <img
          src="/resources/um/graphics/quality_bars_good.svg"
          alt={intl.formatMessage({ defaultMessage: 'Good quality' })}
        />
      )
    }

    if (quality === 'acceptable') {
      return (
        <img
          src="/resources/um/graphics/quality_bars_medium.svg"
          alt={intl.formatMessage({ defaultMessage: 'Okay quality' })}
        />
      )
    }

    return (
      <img
        src="/resources/um/graphics/quality_bars_bad.svg"
        alt={intl.formatMessage({ defaultMessage: 'Bad quality' })}
      />
    )
  }

  if (quality === 'excellent') {
    return <IconComponent name="good-quality" size={size} />
  }

  if (quality === 'acceptable') {
    return <IconComponent name="medium-quality" size={size} />
  }

  return <IconComponent name="bad-quality" size={size} />
}

interface QualityIndicatorProps {
  participantId: Participant['id']
  reason?: string
  details?: string
  enableGlow?: boolean
}

const QualityIndicatorComponent = ({
  participantId,
  reason,
  details = '',
  enableGlow = true,
}: QualityIndicatorProps) => {
  const quality = useParticipantQualityStats(participantId)

  if (!quality) return null

  let tooltipText

  if (quality === 'acceptable' || quality === 'bad') {
    tooltipText = `${reason}. ${details}`
  } else {
    tooltipText = intl.formatMessage({
      defaultMessage: 'We have not detected any issues',
    })
  }

  return (
    <div className="quality-indicator-component">
      <TooltipComponent title={tooltipText}>
        {getIcon(quality, enableGlow)}
      </TooltipComponent>
    </div>
  )
}

export { QualityIndicatorComponent }
